const state = {
  grades: [
    { value: '0', name: 'Kindergarten' },
    { value: '1', name: '1st Grade' },
    { value: '2', name: '2nd Grade' },
    { value: '3', name: '3rd Grade' },
    { value: '4', name: '4th Grade' },
    { value: '5', name: '5th Grade' },
    { value: '6', name: '6th Grade' },
    { value: '7', name: '7th Grade' },
    { value: '8', name: '8th Grade' },
    { value: '9', name: '9th Grade' },
    { value: '10', name: '10th Grade' },
    { value: '11', name: '11th Grade' },
    { value: '12', name: '12th Grade' },
    { value: '13', name: 'College' },
  ],
  subjects: ['ELA', 'Math', 'ELA + Math', 'Science', 'Art', 'Music'],
};

const mutations = {};

const actions = {};

const getters = {
  grades: (state) => {
    return state.grades;
  },
  subjects: (state) => {
    return state.subjects;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
